// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkedIn: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 23" enableBackground="new 0 0 24 23" xmlSpace="preserve" fill="currentColor">
<path d="M0.61,22.52h4.68V7.55H0.61V22.52z"/>
<path d="M18.07,7.4c-2.68,0-4.36,1.47-4.67,2.49V7.55H8.14c0.07,1.25,0,14.97,0,14.97h5.26v-8.1c0-0.45-0.02-0.9,0.12-1.22
	c0.36-0.9,1.14-1.83,2.53-1.83c1.83,0,2.65,1.38,2.65,3.41v7.75H24v-8.32C24,9.56,21.39,7.4,18.07,7.4"/>
<path d="M2.86,0.48C1.13,0.48,0,1.6,0,3.08c0,1.45,1.1,2.59,2.79,2.59h0.03c1.76,0,2.85-1.15,2.85-2.6C5.65,1.6,4.58,0.48,2.86,0.48
	"/>
</svg>;
};

export default React.memo(LinkedIn);
